export class CreateCorporateDataEvent {}
